export default "https://cdn-web.disco.co/connect-slack-cover-photo-5383c8ac19de7e8a9da9d480b5e17f22.png";